// extracted by mini-css-extract-plugin
export default {"image_upload":"styles_image_upload__1ST2t"};